import { render, staticRenderFns } from "./dkr.vue?vue&type=template&id=2ca0997e&scoped=true"
import script from "./dkr.vue?vue&type=script&lang=js"
export * from "./dkr.vue?vue&type=script&lang=js"
import style0 from "./dkr.vue?vue&type=style&index=0&id=2ca0997e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0997e",
  null
  
)

export default component.exports